module.exports = __webpack_public_path__ + "static/media/icon_60.94967f04.svg";